import type React from 'react'

import 'react-datepicker/dist/react-datepicker.css'
import TextInput from '@/components/DEPRECATED_UI/TextInput'
import { Select, ItemHeader, InputGroup } from '@/components/Style/Common'
import type { IncomeProperties } from '@/types/Income'

import type { Property, PropertyDispatch } from './Behaviour/PropertyDispatch'

export const FREQUENCY_OPTIONS = [
  { label: 'Annually', value: 'Annually' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Daily', value: 'Daily' },
  { label: 'Hourly', value: 'Hourly' },
]

interface Props {
  incomeProperties: IncomeProperties
  propertyDispatch: PropertyDispatch
  frequencyProperty: Property
  amountProperty: Property
  hourlyProperty?: Property
}

const IncomePropertiesInput: React.FC<Props> = ({
  incomeProperties,
  propertyDispatch,
  frequencyProperty,
  amountProperty,
  hourlyProperty,
}) => {
  return (
    <div>
      <ItemHeader>Income Details</ItemHeader>
      <InputGroup>
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            propertyDispatch.set(amountProperty, +e.target.value)
          }
          type="number"
          value={incomeProperties.value}
          label="Income Value (£)"
        />
        <Select
          value={incomeProperties.frequency}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            propertyDispatch.set(frequencyProperty, e.target.value)
          }
        >
          {FREQUENCY_OPTIONS.filter(function (option) {
            // eslint-disable-next-line eqeqeq
            if (option.value == 'Hourly' && hourlyProperty == null) {
              return false
            }

            return true
          }).map(({ label, value }, i) => (
            <option key={i} value={value}>
              {label}
            </option>
          ))}
        </Select>
      </InputGroup>
      {
        // eslint-disable-next-line eqeqeq
        hourlyProperty != null && incomeProperties.frequency == 'Hourly' && (
          <div>
            <TextInput
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                propertyDispatch.set(hourlyProperty, +e.target.value)
              }
              type="number"
              value={incomeProperties.averageHoursAWeek}
              label="Average Hours Per Week"
            />
          </div>
        )
      }
    </div>
  )
}

export default IncomePropertiesInput
